import {Component} from "./Components/Component";
import {createLogger} from "./util/logger";
import {hasParent} from "./util/dom";

const console = createLogger("App", true);

export class App {


    /**
     * @param {Component[]} modules
     */
    constructor(modules) {
        this.modules = modules;

        /**
         * @type {Map<HTMLElement, {[name: string]: Component}>}
         */
        this.moduleInstances = new Map();

        this.onInit()

        this.debugModuleInstances();
    }

    onInit() {
        this.initModules();

        this.mutationObserver = new MutationObserver(this.mutationObserverCallback.bind(this));

        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    onDestroy() {
        this.mutationObserver.disconnect();
    }

    /**
     *
     * @param {MutationRecord[]} mutations
     * @param {MutationObserver} observer
     */

    mutationObserverCallback(mutations, observer) {

        mutations.forEach((mutation) => {

            mutation.removedNodes.forEach((node) => {
                // Only destroy element nodes
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                if (!document.body.contains(node)) {
                    this.destroy(node);
                }

            });

            this.initModules(mutation.target);

        });
    }

    /**
     *
     * @param {HTMLElement|undefined} root
     */
    initModules(root = undefined) {
        root = root || document;

        this.modules.forEach((component) => {
            root.querySelectorAll(component.getModuleSelector()).forEach((element) => {
                try {
                    if (!this.getRegisteredModuleInstance(element, component.name)) {
                        this.registerModuleInstance(element, component.name, component.create(element, true));

                    }
                } catch (e) {
                    console.error("Error instantiating module " + component.name + ": " + e.message, e);
                }
            });
        });

        window.lazyload.update();
    }

    refresh() {
        console.log("refresh");
        this.destroy();
        this.initModules();
    }

    /**
     * Destroys all module instances
     * @param {HTMLElement|undefined} context Optional context to destroy modules in
     */
    destroy(context) {
        this.debugModuleInstances();
        console.log("destroy", context);

        for (const [element, instances] of this.moduleInstances.entries()) {
            if (context && !hasParent(element, context)) {
                continue;
            }

            Object.keys(instances).forEach((name) => {
                instances[name].destroy();
                this.unregisterModuleInstance(element, name);
            });
        }

        this.debugModuleInstances();
    }

    getRegisteredModuleInstance(element, name) {
        const data = this.moduleInstances.get(element) || {};

        if (name) return data[name];
        return data;
    }

    registerModuleInstance(element, name, instance) {
        this.moduleInstances.set(element, {
            ...this.moduleInstances.get(element) || {},
            [name]: instance,
        });
    }

    /**
     *
     * @param {HTMLElement} element
     * @param {string|undefined} name Optional component name, if undefined unregisters all components
     */
    unregisterModuleInstance(element, name = undefined) {
        let data = this.moduleInstances.get(element) || {};

        if (name) {
            delete data[name];
        } else {
            data = {};
        }

        if (Object.keys(data).length) {
            this.moduleInstances.set(element, data);
        } else {
            this.moduleInstances.delete(element);
        }

    }


    debugModuleInstances() {
        return;
        console.log("modules");
        this.moduleInstances.forEach((instances, element) => {
            console.log(instances);
        });
    }





}
